<ta-link
  [taRouterLink]="active ? null : subsection.link"
  [fragment]="subsection.fragment"
>
  <li
    class="subsection bold ph--4 pv--3"
    (mouseenter)="hover = true"
    (mouseleave)="hover = false"
    [class.hover]="hover && !active"
    [class.active]="active"
    (click)="toggleExpanded()"
  >
    <div class="flex flex--justify-content-between flex--align-items-center">
      <span> {{ subsection.title }} </span>

      <ta-icon
        *ngIf="subsection.headers?.length > 0"
        [icon]="expanded ? 'minus' : 'plus'"
        [@plusMinus]="expanded ? 'minus' : 'plus'"
      ></ta-icon>
    </div>
  </li>
</ta-link>

<li *ngIf="active && expanded" [@expandIn] [@collapseOut]>
  <ta-subsection-headers [subsection]="subsection"></ta-subsection-headers>
</li>

<div class="border--bottom mh--4"></div>
